export const numberToCurrency = (number) => {
  if (number === null || number === undefined) return '';

  return number.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });
};

export const normalizeTextForSearch = (text) => {
  if (!text) return '';
  if (typeof text !== 'string') return '';
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "");
};

export const formatCnpj = (cnpj) => {
  if (typeof cnpj !== 'string') return '';
  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};
